export interface AuthUser {
	id: number
	email: string
	firstName?: string
	lastName?: string
	profilePicture?: string | null
}

export interface AuthState {
	token: string | null
	user: AuthUser | null
}

const STORAGE_KEY = 'gp_auth'

export const getSession = (): AuthState | null => {
	const raw = localStorage.getItem(STORAGE_KEY)
	if (!raw) return null
	try {
		return JSON.parse(raw) as AuthState
	} catch {
		return null
	}
}

export const getToken = (): string | null => getSession()?.token ?? null

export const setSession = (auth: AuthState): void => {
	localStorage.setItem(STORAGE_KEY, JSON.stringify(auth))
}

export const clearSession = (): void => {
	localStorage.removeItem(STORAGE_KEY)
}
